module.exports = __webpack_public_path__ + "img/102034.16dc2569.png";